import { readCookie } from './utils';

const GA_COOKIE_NAME = '_ga';

function extractClientId(gaCookie: string | null): string | null {
	if (!gaCookie) return null;
	const [, , clientIdPart1, clientIdPart2] = gaCookie.split('.');
	return clientIdPart1 && clientIdPart2
		? `${clientIdPart1}.${clientIdPart2}`
		: null;
}

/**
 * Returns a getter for the GA4 Client ID, re-parsed from the first-party
 * `_ga` cookie (format `GA1.<depth>.<clientId part 1>.<clientId part 2>`) on
 * every call — so it can be attached to lead/deal creation and cross-referenced
 * with Google Analytics attribution models (cross_channel, last_click,
 * first_click).
 *
 * Reads `document.cookie` directly instead of `useCookie`: GTM/gtag.js sets
 * `_ga` asynchronously, often after hydration, and a `useCookie` ref is only
 * captured once at setup — without `experimental.cookieStore` (not enabled in
 * this app) it never observes a cookie set later by external JS. On a first
 * visit that would make `gaClientId` incorrectly stick at `null` for the rest
 * of the page's lifetime. Re-reading on every call (like `getOrCreateSessionId`)
 * means callers always see the cookie as it exists at THAT moment.
 */
export function useGaClientId(): () => string | null {
	return () => {
		if (!import.meta.client) return null;

		return extractClientId(readCookie(GA_COOKIE_NAME));
	};
}
